import React from "react";
import styled, { keyframes } from "styled-components";
import { padding } from "styled-system";


const CircleSlider = keyframes`
 0% {
    width: 50%;
    height: 50%;
  }
  50% {
    width: 100%;
    height: 100%;
  }
  51% {
    width: 50%;
    height: 50%;
  }
  100% {
    width: 50%;
    height: 50%;
  }
`;

const scaleCircle = keyframes`
   0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  51% {
    transform: scale(1);
  }
  100% {
    transform: scale(1);
  }
`;

const RotateCircleSlider = keyframes`
 0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
`;

const Size = styled.div.attrs((small: any, padding?: any) => ({
  type: "text",
  size: small ? 5 : undefined,
}))`
  border-radius: 3px;
  border: 1px solid palevioletred;
  display: block;
  margin: 0 0 1em;
  padding: ${padding}px;

  ::placeholder {
    color: palevioletred;
  }
`;

const Warrper = styled.div<{ width: string; height: string }>`
  --width-Circle: ${({ width }) => width && width};
  --height-Circle: ${({ height }) => height && height};

  .circleGroup {
    width: var(--width-Circle);
    height: var(--height-Circle);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .bigCircleContainer {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .bigCircleGroup {
    width: 100%;
    height: 100%;
    background-color: rgba(254, 230, 146, 0.25);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .circleFloor {
    width: calc(var(--width-Circle) / 2);
    height: calc(var(--height-Circle) / 2);
    background-color: #f7da57;
    border-radius: 50%;
    position: relative;
  }
  .bigCircle {
    width: calc(var(--width-Circle) / 2);
    height: calc(var(--height-Circle) / 2);
    background-color: #f7da57;
    border-radius: 50%;
  }

  .smallCircle {
    width: 31%;
    height: 31%;
    position: absolute;
    background-color: #f7da57;
    border-radius: 50%;
    bottom: -85%;
    left: 17.25%;
  }

  .bigCircleScale {
    animation-name: ${scaleCircle};
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-delay: 0.5s;
  }
  .bigCircleSlider {
    animation-name: ${CircleSlider};
    animation-duration: 1s;
    animation-iteration-count: infinite;
  }
  .bigCircleGroupRotate {
    animation-name: ${RotateCircleSlider};
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
`;

interface SquareSlider {
  width: string;
  height: string;
}

const Circle: React.FC<SquareSlider> = ({ width, height }) => {
  return (
    <Warrper width={width} height={height}>
      <div className="circleGroup">
        <div className="bigCircleContainer bigCircleGroupRotate">
          <div className="bigCircleGroup bigCircleSlider">
            <div className="circleFloor">
              <div className="bigCircle bigCircleScale"></div>
              <div className="smallCircle"></div>
            </div>
          </div>
        </div>
      </div>
    </Warrper>
  );
};

export default React.memo(Circle);
